import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
  {
    question: "How much loan can I get against my gold?",
    answer: "The loan amount depends on the weight and purity of your gold, prevailing gold prices and the lender's applicable LTV norms."
  },
  {
    question: "Do I need a good credit score?",
    answer: "Since a gold loan is fully secured by your gold assets, a strict credit score check is usually not required by most lenders."
  },
  {
    question: "What documents do I need?",
    answer: "Typically, basic KYC documents like your Aadhaar card, PAN card, and a photograph are sufficient."
  },
  {
    question: "Do I have to sell my gold?",
    answer: "No, your gold is only pledged as collateral. You retain ownership and get your gold back once the loan is fully repaid."
  },
  {
    question: "How quickly can I get the money?",
    answer: "Gold loans are usually processed very quickly, often within a few hours after your gold is evaluated."
  },
  {
    question: "Will DigitMoney keep my gold?",
    answer: "No, DigitMoney does not keep your gold. Your gold is safely stored in certified vaults belonging to our RBI-regulated lending partners."
  }
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const scrollToForm = () => {
    const formElement = document.getElementById("personal-loan-form");
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div id="v3-strict-scope" className="faq-section-wrapper">
      <div className="faq-container">

        <div className="faq-grid">
          {/* Left Column: Title and Description */}
          <div className="faq-left-col">
            <span className="faq-label">CUSTOMER QUESTIONS</span>
            <h2 className="faq-title">FAQs</h2>
            <p className="faq-description">
              Everything you might want to know before checking eligibility. Still curious? Write to us — real humans reply.
            </p>
          </div>

          {/* Right Column: Accordion List */}
          <div className="faq-right-col">
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                >
                  <button
                    className="faq-question-btn"
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className="faq-question-text">{item.question}</span>
                    <span className="faq-toggle-icon">
                      {activeIndex === index ? '×' : '+'}
                    </span>
                  </button>

                  {activeIndex === index && (
                    <div className="faq-answer-container">
                      <p className="faq-answer-text">{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom CTA Card */}
        <div className="cta-card">
          <div className="cta-content-left">
            <div className="cta-image">
              <img src="/assets/img/GoldBricks-2.svg" alt="Gold Bricks" />
            </div>
            <div className="cta-text">
              <h3>Ready to check your eligibility?</h3>
              <p>Takes less than a minute. No commitment required.</p>
            </div>
          </div>

          <button
            type="button"
            className="cta-btn"
            onClick={scrollToForm}
          >
            Check my gold loan options
          </button>
        </div>

      </div>
    </div>
  );
}